import { Heading_1 as Heading1, FormBody } from '@huggg/react-components';
import PropTypes from 'prop-types';
import React from 'react';
import BackButton from '../BackButton/BackButton';
import { PersonalDetailsDialog } from './PersonalDetailsDialog';
import { formModel } from './formModel';
import styles from './prepaidCard.module.scss';

export const PrepaidForm = (props) => {
  const { onSubmit, onBack, formData } = props;
  return (
    <>
      <div className={styles.personalDetailsHeader}>
        <Heading1>Add your personal details</Heading1>
        <PersonalDetailsDialog />
      </div>
      <FormBody
        onConfirm={onSubmit}
        buttonCopy="SUBMIT MY REQUEST"
        initialValues={formData}
        model={formModel}
      />
      <BackButton onClick={onBack} />
    </>
  );
};

PrepaidForm.propTypes = {
  formData: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};
